export const gtag: any = (window as any).gtag;

export const registerGoogleAnalytics = (id: string) => {
    gtag('config', id);
};
